export { DesignCard, DesignCardTint, useInsideDesignCard, useGlassmorphicDefault } from "@hexclave/dashboard-ui-components";
export type { DesignCardProps, DesignCardTintProps } from "@hexclave/dashboard-ui-components";
